export const enum SnCameraDisposition {
  External = 'External',
  Internal = 'Internal',
}
